import { render, staticRenderFns } from "./Signin.vue?vue&type=template&id=3670b61e&scoped=true&lang=pug&"
import script from "./Signin.vue?vue&type=script&lang=js&"
export * from "./Signin.vue?vue&type=script&lang=js&"
import style0 from "./Signin.vue?vue&type=style&index=0&id=3670b61e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670b61e",
  null
  
)

/* custom blocks */
import block0 from "./Signin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports